<template>
    <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
      <div
        class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25"
      >
        
        
      </div>
      <div class="card-body p-15 p-sm-20 p-md-25">
        <div class="col-md-12">
        <div class="row">
          <!-- <form class="row" @submit.prevent="rechercher"> -->
            
            <div class="col">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10">
                 Mot clé
                </label>
                <Field 
                  style="max-height: 42px;"
                  v-model="searchTerm"
                  @keyup="rechercher" 
                  name="mot" 
                  type="text" 
                  aria-disabled="true"
                  class="form-control shadow-none fs-md-15 text-black" 
                  placeholder="Recherche par mot clé"/>
              </div>
            </div>
  
            <div class="col">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10">
                  Date Debut
                </label>
                <Field name="dateDebut" type="date" v-model="_dateDebut"  :value="getCurrentDate()"
                class="form-control shadow-none fs-md-15 text-black"/>
                <ErrorMessage name="dateDebut" class="text-danger"/>
              </div>
            </div>
  
            <div class="col">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10">
                  Date Fin 
                </label>
                <Field name="dateFin" type="date"  v-model="_dateFin"  :value="getCurrentDate()"
                class="form-control shadow-none fs-md-15 text-black"/>
                <ErrorMessage name="dateFin" class="text-danger"/>
              </div>
            </div>

            <div class="col">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10">
                  Client 
                </label>
                <Field v-model="_client" name="client" v-slot="{ field }">
                  <Multiselect
                    :options="
                    async (query) => {
                      const results = await searchClient(query);
                      if (results && results.length > 0) {
                        return results;
                      } else if (query.length >= 3) {
                        return [
                          { value: '', label: 'Aucun enregistrement trouvé' },
                        ];
                      } else {
                        return [];
                      }
                    }"
                    noOptionsText="Tapez au moins deux caractères"
                    :filter-results="false" 
                    :min-chars="3" 
                    :delay="0"
                    :searchable="true"
                    v-model="field.value"
                    v-bind="field"
                    placeholder="Sélectionner un client"
                  />
                </Field>
                <ErrorMessage name="client" class="text-danger"/>
              </div>
            </div>

            <div class="col">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10">
                  Vente 
                </label>
                <Field v-model="_vente" name="vente" v-slot="{ field }">
                  <Multiselect
                    :options="venteOptions"
                    :searchable="true"
                    v-model="field.value"
                    v-bind="field"
                    placeholder="Sélectionner une vente"
                  />
                </Field>
                <ErrorMessage name="vente" class="text-danger"/>
              </div>
            </div>
  
            <div class="col">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10">
                  Agent
                </label>
                <Field v-model="_agent" name="agent" v-slot="{ field }">
                  <Multiselect
                    :options="agentOptions" 
                    :searchable="true"
                    v-model="field.value"
                    v-bind="field"
                    placeholder="Sélectionner un agent"
                  />
                </Field>
                <ErrorMessage name="agent" class="text-danger"/>
              </div>
            </div>
            
  
          <!-- </form> -->
        </div>
        </div>
        <hr>
        <div class="table-responsive">
          <table class="table text-nowrap align-middle mb-0">
            <thead>
              <tr>
                <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                  DATE
                </th>
                <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0" >
                  CLIENT
                </th>
                <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0" >
                  MONTANT
                </th>
                <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0" >
                  MT RESTANT 
                </th>
                <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0" >
                  VENTE
                </th>
                <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0" >
                  GROUPEMENT
                </th>
                <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0" >
                  AGENT
                </th>
                <th scope="col"  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
                >Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(reg, index) in reglements" :key="index">
                <td class="shadow-none lh-1 fw-medium text-primary">
                  {{ format_Date(reg.dateReglement) }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                  {{ reg.vente?.client?.code }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-primary">
                  {{ reg.montant }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                  {{ reg.restAPayer }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-primary">
                  {{ '#'+reg.vente?.id }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-primary">
                  {{ reg?.groupementReglement?.id  }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-primary">
                  {{ reg?.vente?.client?.agent?.nom + ' ' + reg?.vente?.client?.agent?.prenoms }}
                </td>
                <td
                class="shadow-none lh-1 fw-medium text-end pe-0 sm"
                >
                <div class="dropdown">
                    <span class="badge text-white bg-primary fs-15 dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                        Actions 
                        <i class="flaticon-chevron-2 position-relative ms-5 top-2 fs-15"></i>
                    </span>
                    <ul class="dropdown-menu">
                        <!-- <li>
                            <router-link :to="{ name: 'ViewAbonnementPage', params: { id: abonne.id } }" 
                                        class="dropdown-item d-flex align-items-center">
                                <i class="flaticon-eye lh-1 me-8 position-relative top-1"></i>
                                Détails
                            </router-link>
                        </li> -->
                        <!-- <li v-if="abonne.etat == 'En attente' && checkPermission('ValidAbonnement')">
                            <router-link :to="{ name: 'ViewAbonnementPage', params: { id: abonne.id } }" class="dropdown-item d-flex align-items-center">
                                <i class="flaticon-check lh-1 me-8 position-relative top-1"></i>Valider l'abonnement
                            </router-link>
                        </li> -->
                    </ul>
                </div>
                </td>
              </tr>
              <tr>
                <td colspan="6" class="text-end"> Total : </td>
                <td> <h5> <b>{{ formatMontant(total) }}</b></h5>  </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center">
          
          <PaginationComponent :page="page" :totalPages="totalPages" :totalElements="totalElements" :limit="limit" @paginate="handlePaginate" />
  
        </div>
      </div>
    </div>
  
  </template>
  
  <script lang="ts">
  import { defineComponent, onMounted, ref, watch } from "vue";
  import { Form, Field, ErrorMessage } from 'vee-validate';
  import ApiService from "@/services/ApiService";
  import { useRouter } from 'vue-router';
  import { format_date,suppression,format_Date, hideModal, showModal,separateur, error,success, getCurrentDate } from "@/utils/utils";
  import PaginationComponent from '@/components/Utilities/Pagination.vue';
  import JwtService from "@/services/JwtService";
  import Multiselect from '@vueform/multiselect';
  import axios from "axios";
  import { Reglement } from '../../models/Reglement';
  
  export default defineComponent({
      name: "PointDesReglements",
      components: {
        // Form,
        Field,
        Multiselect,
        PaginationComponent,
    },
    setup: () => {
      
  
      const reglements = ref<Array<Reglement>>([]);
      const reglement = ref<Reglement>();
      const ResiliationRef = ref<null | HTMLElement>(null);
      const modeleOptions = ref([]);
      const agentOptions = ref([]);
      const clientOptions = ref([]);
      const venteOptions = ref([]);
      const categorieAbonneOptions = ref([]);
      const total = ref(0);

      const nooptions = "La liste est vide";
      const noResultText = "Aucun enregistrement trouvé";
      const noOptionsTextAbb = ref("Tapez au moins trois caractères");
  

  
      // BEGIN PAGINATE
      const _dateDebut = ref(null);
      const _dateFin = ref(null);
      const _agent = ref('');
      const _client = ref('');
      const _vente = ref('');
      const searchTerm = ref('');
      const page = ref(1);
      const totalPages = ref(0);
      const limit = ref(10);
      const totalElements = ref(0);
      const router = useRouter();
  
      const handlePaginate = ({ page_, limit_ }) => {
        try {
          page.value = page_;
          getAll(page_, limit_, searchTerm.value, _agent.value ?? undefined, _dateDebut.value ?? undefined, _dateFin.value ?? undefined, _client.value ?? undefined, _vente.value ?? undefined);
        } catch (error) {
          //
        }
      };
     
  
      watch([_dateDebut, _dateFin, _agent, _client, _vente, searchTerm], () => {
        console.log('watching', _dateDebut, _dateFin, _agent);
        rechercher();
      });

    
  
      function rechercher(){
        
        getAll(page.value, limit.value, searchTerm.value, _agent.value ?? undefined, _dateDebut.value ?? undefined, _dateFin.value ?? undefined, _client.value ?? undefined, _vente.value ?? undefined);
      }
  
      // END PAGINATE
      const resiliation = (id: number) => {
        //show modal
        showModal(ResiliationRef.value!);
      }

  
      const fetchAgent = async () => {
        console.log('fetching agents');
        ApiService.get("/utilisateurs/agent")
          .then(({ data }) => {
            agentOptions.value = data.data.map((p) => {
                return {
                  value: p.id,
                  label: p.nom + " " + p.prenoms,
                };
            });
          })
          .catch(({ response }) => {
          // produitsError.value = true;
          });
      };

      const fetchClient = async () => {
        ApiService.get("/clients")
            .then(({ data }) => {
            clientOptions.value = data.data.data.map((p) => {
              return {
                value: p.id,
                label: "[ "+ p.code +" ] " +p.nom + " " + p.prenoms,
              };
            });
            console.log('clients', clientOptions.value);
            })
            .catch(({ response }) => {
            // produitsError.value = true;
            });
      };

      const searchClient = async (key) => {
        try {
          const  data  = await ApiService.get("/clients/recherche/" + key);
          clientOptions.value = data.data.data.map((p) => ({
            value: p.id,
            label: "[ " + p.code + " ] " + p.nom + " " + p.prenoms,
          }));
          console.log("clients", clientOptions.value);
          // if (clientOptions.value.length == 0) {
          //   noOptionsTextAbb.value = noResultText;
          // } else {
          //   noOptionsTextAbb.value = 'Tapez au moins trois caractères';
          // }
          return clientOptions.value;
        } catch (error) {
          // produitsError.value = true;
          return [];
        }
      };

      const fetchVente = async () => {
        ApiService.get("/ventes")
            .then(({ data }) => {
              venteOptions.value = data.data.data.map((p) => {
                return {
                  value: p.id,
                  label: p.client.code+" - "+p.montant,
                };
              });
              console.log('clients', venteOptions.value);
            })
            .catch(({ response }) => {
            // produitsError.value = true;
            });
      };
  

  
      function getAll(page = 1, limi = 10, searchTerm = '', _agent = '', _dateDebut = '' , _dateFin = '', _client = '', _vente = '') {
        console.log('fetching reglements', _agent, _client, _vente);
        return ApiService.get(`/reglements?page=${page}&limit=${limi}&mot=${searchTerm}&agent=${_agent}&dateDebut=${_dateDebut}&dateFin=${_dateFin}&client=${_client}&vente=${_vente}&ok`)
          .then(({ data }) => {
            reglements.value = data.data.data
            totalPages.value = data.data.totalPages;
            limit.value = data.data.limit;
            totalElements.value = data.data.totalElements;
            total.value = data.data.totalReglement.totalReglement;
            console.log('reglements', total.value);
            // total.value = reglements.reduce((acc,p) => {
            //   const mt = p.montant !== null && !isNaN(p.montant) ? parseFloat(p.montant.toString()) : 0;
            //   return acc + mt;
            // }, 0)
          })
          .catch(({ response }) => {
            // error(response.data.message);
          });
      }
  
      onMounted(async () => {
        console.log('mounted');
          await fetchAgent();
          await fetchClient();
          await fetchVente();
          await getAll();
      });
  
    //   const addValidAbonnementModalRef = ref<null | HTMLElement>(null);
  
    //   const valideAbonnement = () => {
    //   const dataToSend = {
    //     id : selectedAbonnement?.value?.id.toString()      };
    //     console.log('data', dataToSend);
    //     ApiService.put("/valide/abonnements/"+ selectedAbonnement?.value?.id.toString(), dataToSend)
    //       .then(({ data }) => {
    //         if(data.code == 200) { 
    //           success(data.message);
    //           hideModal(addValidAbonnementModalRef.value);
    //           getAll();
    //         }
    //       }).catch(({ response }) => {
    //         error(response.data.message);
    //       });
    //   };
  
  
    //   const privileges = ref<Array<string>>(JwtService.getPrivilege());
  
    //   const checkPermission = (name) => {
    //     return privileges.value.includes(name);
    //   }

    const formatMontant = (montant) => {
      return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'XOF' }).format(montant);
    };
      
      return { 
        reglements,
        // checkPermission,
        modeleOptions,
        agentOptions,
        clientOptions,
        venteOptions,
        categorieAbonneOptions,
        format_date,
        suppression,
        getAll,
        resiliation,
        // resilier,
        page, 
        totalPages,
        limit,
        format_Date,
        totalElements,
        handlePaginate,
        separateur,
        searchTerm,
        rechercher,
        Multiselect,
        getCurrentDate,
        _dateDebut,
        _dateFin,
        _agent,
        _client,
        _vente,
        total,
        formatMontant,
        searchClient,
        nooptions,
        noResultText,
        noOptionsTextAbb,
        // valideAbonnement,
        // addValidAbonnementModalRef
      };
    },
  });
  </script>
  
  